import type { InventoryTracking, TerminalFlow } from "@jidlomat/terminal-core/types/terminalFlow";

export type FlowKind = "rfid" | "manual";

/**
 * Which flow a fridge runs. A fridge without readers runs the manual flow; every other fridge, one that
 * does not say what it tracks included, runs the RFID flow. Today only the kiosk's URL says it (see
 * readInventoryTrackingFromUrl); the backend does not report it yet.
 */
export const resolveFlowKind = (inventoryTracking: InventoryTracking | null): FlowKind =>
	inventoryTracking === "NONE" ? "manual" : "rfid";

// One dynamic import per flow: the bundler cuts a chunk at each of them, so a tablet downloads only
// the flow of its fridge.
const loaders: Record<FlowKind, () => Promise<TerminalFlow>> = {
	rfid: () => import("@jidlomat/terminal-flow-rfid/flow").then((module) => module.rfidFlow),
	manual: () => import("@jidlomat/terminal-flow-manual/flow").then((module) => module.manualFlow),
};

export const loadFlow = (kind: FlowKind): Promise<TerminalFlow> => loaders[kind]();
